export default "__VITE_ASSET__GuKCxYOW__"